import React from "react";
import styled from "styled-components";

import { device } from "../../Util/Breakpoints";
const BarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
  @media${device.laptop} {
    flex-direction: nowrap;
  }
  .label{
    text-align: center;
    margin-top: 8px;
    font-family: 'Inter';
    font-weight: 700;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.15px;
    white-space: nowrap;
  }
`;

const BarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AnimatedDiv = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${props => props.color || '#0f0865'};
  transform: scale(${props => (props.inView ? 1 : 0.8)});
  transition: transform 1.2s ease;
  border-radius: 1000px;
  padding: 20px 32px;
  text-align: center;
  font-family: 'Inter';
  width: fit-content;
  margin: auto auto 8px;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.6px;
`;

const Bar = styled.div`
  width: 100%;
  max-width: 144px;
  background: ${props => props.color};
  margin-top: 8px;
  opacity: ${props => (props.inView ? 1 : 0)};
  transform: ${props => (props.inView && props.height !== "0px" ? "scaleY(1)" : "scaleY(0)")};
  transform-origin: bottom;
  transition: transform 2.0s ease, opacity 2.0s;
  height: ${props => props.height};
`;

const Line = styled.div`
  width: 1px;
  height: ${props => (props.inView ? "24px" : "0px")};
  background: #000;/* ${props => props.color} */
  margin: 0 auto;
  opacity: ${props => (props.inView ? 1 : 0)};
  transition: height 1.2s ease, opacity 1.2s;
`;

const DoubleBar = ({
  bar1,
  bar2,
  inView
}) => (
  <BarWrapper>
    <BarContainer>
      <AnimatedDiv inView={inView}>
        <div>{bar1.value}</div>
      </AnimatedDiv>
      <Line color={bar1.lineColor || bar1.color} inView={inView} />
      <Bar color={bar1.color} height={bar1.height} inView={inView} />
        <div className="label">{bar1.label}</div>
    </BarContainer>
    <BarContainer>
      <AnimatedDiv inView={inView}>
        <div>{bar2.value}</div>
      </AnimatedDiv>
      <Line color={bar2.lineColor || bar2.color} inView={inView} />
      <Bar color={bar2.color} height={bar2.height} inView={inView} />
      <div className="label">{bar2.label}</div>
    </BarContainer>
  </BarWrapper>
);

export default DoubleBar;
